var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receiver-container"},[_c('img',{staticClass:"icon-receiver",attrs:{"height":"12","width":"12","src":_vm.typeImage[_vm.receiver.icon_type]}}),_vm._v(" "),_c('div',{staticClass:"receiver-text",style:(_vm.styles)},[_vm._v(_vm._s(_vm.receiver.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409f601a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publication/receiver.vue
// module id = 765
// module chunks = 0 1 3